import useAsync from '../hooks/useAsync'
import { getWebhookDeliveries } from '../api/leadService'
import StateView from '../components/StateView'
import { PageHeader } from '../components/Layout'
import WebhookStatusTable from '../components/WebhookStatusTable'
export default function WebhooksPage() {
  const { state, data, reload } = useAsync(getWebhookDeliveries)
  return (<><PageHeader title="Webhook Deliveries"><button className="btn btn-outline-primary btn-sm" onClick={reload}>↻ Refresh</button></PageHeader>
    <StateView state={state} onRetry={reload} emptyText="No webhook deliveries yet."><WebhookStatusTable rows={data || []} /></StateView></>)
}
